import React from 'react'

export const PitchPage = () => {
  return (
    <div className="w-screen h-screen bg-[#1E1E2E] overflow-hidden">
      <iframe
        src="https://pitch.com/embed-link/jepkjd"
        title="Pitch presentation"
        allow="fullscreen; clipboard-write"
        allowFullScreen
        className="w-full h-full"
        style={{ border: 0 }}
      />
      <a
        href="/pitch.pdf"
        download
        className="fixed bottom-20 right-4 z-50 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#6C63FF] text-white shadow-lg hover:bg-[#4A45B2] focus:outline-none focus:ring-2 focus:ring-white/40"
        aria-label="Download pitch PDF"
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-5 w-5">
          <path fillRule="evenodd" d="M12 3.75a.75.75 0 01.75.75v8.69l2.47-2.47a.75.75 0 111.06 1.06l-3.75 3.75a.75.75 0 01-1.06 0l-3.75-3.75a.75.75 0 111.06-1.06l2.47 2.47V4.5a.75.75 0 01.75-.75z" clipRule="evenodd" />
          <path d="M3.75 15a.75.75 0 01.75-.75h15a.75.75 0 01.75.75v2.25A3.75 3.75 0 0116.5 21H7.5A3.75 3.75 0 013.75 17.25V15z" />
        </svg>
        <span className="hidden sm:inline">Download PDF</span>
      </a>
    </div>
  )
}


